// extracted by mini-css-extract-plugin
export default {"container":"gp-z","heading":"hp-z","text":"ip-z","info":"jp-z","link":"kp-z","fullMaxWidth":"lp-z"};